// extracted by mini-css-extract-plugin
export default {"button":"CallWaiter_button__8Wf5L","image-container":"CallWaiter_image-container__ycO26"};